import { batch } from 'react-redux';

import { doRequest } from '@r1-frontend/do-request';
import { view } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers';
import { EOfferState } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/dto/ISpecOffer';
import { IViewResponse } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/view/dto/responseDto';

import { push as campaignLayerPush } from '@r1-frontend/analytics/campaignLayer';

import { specialOfferAnalytics } from '~/src/features/specialOffersContainer/analytics';
import { setIsPopupOpened, setSelectedOfferId } from '~/src/features/specialOffersContainer/store/actions';
import { setOffer } from '~/src/features/specialOffersContainer/store/actions/thunk';
import { TSpecOffer } from '~/src/features/specialOffersContainer/types';
import { TAppThunkDispatch } from '~/src/store';

export const viewOffer = (offer: TSpecOffer, withAnalytics = true) => async(dispatch: TAppThunkDispatch) => {
    const { title, id, requestId, state, isShowNewDetail } = offer;

    batch(() => {
        dispatch(setSelectedOfferId(requestId));
        dispatch(setIsPopupOpened(true));
    });

    if (withAnalytics) {
        specialOfferAnalytics.showPromoDetails(offer);

        if (isShowNewDetail) {
            specialOfferAnalytics.showOfferWithNewDesign(`discounts:${title}`);
        }
    }

    campaignLayerPush({ id, type: 'spec-offer', actionType: 'open' });

    if (state === EOfferState.NEW) {
        const response = await doRequest.specOffer<IViewResponse>(view(id));

        if (response.isSuccess) {
            dispatch(setOffer({
                id,
                value: { state: response.payload.currentStepId },
            }));
        }
    }
};
